import {FC, useCallback, useEffect, useState} from "react";
import {Controller} from "react-hook-form";
import {format, parse} from "date-fns";
import Select, { GroupBase, MultiValue, OptionsOrGroups } from "react-select";

import useFetch from "src/hooks/useFetch";
import HubInputField from "src/components/inputType";

import {APIEndpoints} from "src/types/apiTypes";
import {DRUG_QTY, INJECTION_SITE, SHIP_TO} from "src/constants/cases";
import {DiagnosisResponseProps, CaseStepOneProps, ProcedureRequestProps, ProductRequestProps} from "./types";
import SiteOfCareComp from "../addCase/siteOfCare";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { ProcedureProps } from "src/pages/addCase/types";

const CaseStepOne: FC<CaseStepOneProps> = ({control, isCloneCase, isVisible, watch, setValue, getValues}): JSX.Element => {
  const [isSiteOfCarePopulated, setSiteOfCarePopulated] = useState<boolean>(isCloneCase || false);
  const [openDatePicker, changeDatePickerVisibility] = useState<boolean>(false)
  const [defaultSiteOfCare, updateDefaultSiteOfCare] = useState(getValues("case_attributes.ship_to"))
  // const [drugQuantiyOptions, updateDrugQuantityOptions] = useState(DRUG_QTY)

  const siteOfCare = watch("case_attributes.ship_to");
  const injectionSite = watch("prescription_attributes.injection_site");
  const category = watch("category");
  const drugName = watch("prescription_attributes.drug_name");

  const populatingSiteOfCare = useCallback(() => {
    if (siteOfCare !== "other") {
      setValue("shipments_attributes", [])
    } else {
      setValue("shipments_attributes", [{
        ship_to_city: "",
        ship_to_state: "",
        ship_to_street: "",
        ship_to_zip: "",
        ship_to_suite: "",
      }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteOfCare]);

  useEffect(() => {
    if (siteOfCare) {
      if (isCloneCase) {
        // check whether it is already populated or not
        if (isSiteOfCarePopulated) {
          // if it is populated then make the check false
          setTimeout(() => setSiteOfCarePopulated(false), 1600)
        } else {
          // site of care data should be populated
          console.log("populatingSiteOfCare() called")
          populatingSiteOfCare()
        }
      } else {
        if (siteOfCare !== defaultSiteOfCare) {
          // call populate function here
          populatingSiteOfCare()
          updateDefaultSiteOfCare(siteOfCare)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [populatingSiteOfCare]);


  useEffect(() => {
    if (category === "rx") setValue("procedure_attributes", {} as ProcedureProps);
    else if (category === null) setValue("procedure_attributes", {cpt_code: ""});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);




  /**
   * @GetProcedureListing API to call getProcedureListing
   */
  const {data: procedureListing} = useFetch<ProcedureRequestProps>(APIEndpoints.GET_PROCEDURE_DROPDOWN);




  /**
   * @SearchDiagnosisBySearchValue search by API for diagnosis
   * @first initialize useFetch() with diagnosis
   * @second search diagnosis by search term
   */
  const {loading: diagnosisLoader, data: rfcListing, mutate: getDiagnosis, removeErrorAndData: clearDiagnosisData} =
    useFetch<DiagnosisResponseProps>(APIEndpoints.GET_DIAGNOSIS_DROPDOWN);

  /** @second */
  const searchDiagnosis = (search: string) => {
    if (typeof search === "string" && search.length >= 2) {
      clearDiagnosisData();
      getDiagnosis(null, null, {search});
    }
  };

  useEffect(() => {
    if (typeof injectionSite === "string" && injectionSite.length > 0) {
      console.log("injectionSite: ", injectionSite)
      searchDiagnosis(injectionSite);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [injectionSite]);





  const { data: productData } = useFetch<ProductRequestProps[]>(APIEndpoints.GET_PRODUCTS);




  return (
    <div className={`card mb-3 ${!isVisible ? 'd-none' : ''}`}>
      <div className="card-header">
        <h4 className="m-0">Getting Started</h4>
      </div>

      <div className="card-body">
        <p>
          In order to process your request for benefit investigation, the following information must be
          completed.
          All
          information is kept confidential according to HIPAA guidelines. Please fill out the fields below as
          completely
          as possible. Missing fields may result in a delay to processing patient benefits in a timely manner.
        </p>

        <div className="row">
          <div className="col-12">
            <Controller
              name="category"
              control={control}
              // defaultValue=""
              render={({field: {value, onChange}}) => (
                <div className="row mb-3">
                  <div className="col-12 col-sm-2">
                    <p className="mb-0 form-label">Benefits Being Requested*</p>
                  </div>

                  <div className="col-12 col-sm-10">
                    <div className="form-check">
                      <input
                        className="form-check-input" type="radio" name="benefits_requested"
                        id="benefits_requested1"
                        checked={value === "med"}
                        onChange={(e) => {
                          if (e.target.checked) onChange("med")
                        }}
                      />
                      <label className="form-check-label" htmlFor="benefits_requested1">
                        Run Medical Benefits Investigation in order to Buy & Bill
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input" type="radio" name="benefits_requested"
                        id="benefits_requested2"
                        checked={value === "rx"}
                        onChange={(e) => {
                          if (e.target.checked) onChange("rx")
                        }}
                      />
                      <label className="form-check-label" htmlFor="benefits_requested2">
                        Run Pharmacy Benefits Investigation and script medication through the
                        Pharmacy
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input" type="radio" name="benefits_requested"
                        id="benefits_requested3"
                        checked={value === "medrx"}
                        onChange={(e) => {
                          if (e.target.checked) onChange("medrx")
                        }}
                      />
                      <label className="form-check-label" htmlFor="benefits_requested3">
                        Complete Benefit investigation for Both - Pharmacy and Medical Benefit
                        (Recommended)
                      </label>
                    </div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>

        {category !== "rx" ? (
          <div className="row">
            <div className="col-lg-6" onFocus={() => changeDatePickerVisibility(false)} tabIndex={-1}>
              <Controller
                name="procedure_attributes.cpt_code"
                control={control}
                // defaultValue={null}
                render={({field, fieldState: {error}}) => (
                  <HubInputField
                    inputId="procedure_attributes.cpt_code"
                    inputLabel="Procedure (CPT)"
                    isRequired={true}
                    isRowBased={true}
                    isRowInsideAnother={true}
                    field={field}
                    error={error}
                    isDropdown={true}
                    isSearchable={false}
                    isTypeAhead
                    inputPlaceholder="Select a Procedure ..."
                    dropdownData={
                      (procedureListing && procedureListing.data && procedureListing.data.map((procedure) => (
                        {
                          value: procedure.code,
                          label: `${procedure.code}-${procedure.description}`
                        }))
                      ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                    }
                  />
                )}
              />
            </div>
          </div>
        ) : null}

        <div className="row">
          <div className="col-lg-6" onFocus={() => changeDatePickerVisibility(false)} tabIndex={-1}>
            <Controller
              name="prescription_attributes.injection_site"
              control={control}
              // defaultValue=""
              render={({field, fieldState: {error}}) => (
                <HubInputField
                  isRequired={true}
                  isRowInsideAnother={true}
                  isRowBased={true}
                  inputId="prescription_attributes.injection_site"
                  inputLabel="Injection Site"
                  inputPlaceholder="Specify Site..."
                  field={field}
                  error={error}
                  isDropdown={true}
                  isSearchable={false}
                  isTypeAhead
                  dropdownData={
                    INJECTION_SITE as unknown as OptionsOrGroups<string, GroupBase<string>>
                  }
                />
              )}
            />
          </div>

          {injectionSite ? (
            <div className="col-lg-6">
              <div className="row mb-3">
                <label htmlFor="prescription_attributes.diagnosis_code"
                  className="form-label col-lg-4 col-md-4 col-12"
                >
                  Diagnosis Code *
                </label>

                <div className="col-lg-8 col-md-8 col-12">
                  <Controller
                    name="prescription_attributes.diagnosis_code"
                    control={control}
                    // defaultValue={[]}
                    render={({field, fieldState: {error}}) => (
                      <>
                        <Select
                          options={
                            (rfcListing && rfcListing.data && rfcListing.data.length > 0 ?
                              rfcListing.data.map((option) => ({
                                value: option.code,
                                label: option.fullname
                              }))
                            : []) as unknown as OptionsOrGroups<string, GroupBase<string>>
                          }
                          id="prescription_attributes.diagnosis_code"
                          className= {error ? "is-invalid" : ""}
                          styles={{
                              control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderBottomRightRadius: 0,
                                  borderTopRightRadius: 0,
                                  borderColor: error ? 'red' : baseStyles.borderColor,

                              })
                          }}
                          isSearchable={true}
                          isMulti={true}
                          placeholder="Enter Diagnosis Code"
                          {...field}
                          noOptionsMessage={() => diagnosisLoader ? "Loading..." : "No diagnosis codes"}
                          value={
                            field.value.map((item) => ({
                              value: item,
                              label: item,
                            })) as unknown as MultiValue<unknown>
                          }
                          onChange={
                            (val) => {
                              field.onChange(val.map((item: unknown) => (item as {
                                value: string;
                              }).value))
                            }
                          }
                        />

                        {error && error.message ? (
                          <div className="text-danger text-small mt-2">{error.message}</div>
                        ) : null}
                      </>
                    )}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>

        <div className="row">
          <div className="col-lg-6" onFocus={() => changeDatePickerVisibility(false)} tabIndex={-1}>
            <Controller
              name="prescription_attributes.drug_name"
              control={control}
              // defaultValue={[]}
              render={({field, fieldState: {error}}) => (
                <HubInputField
                  inputId="prescription_attributes.drug_name"
                  isRowBased={true}
                  isRowInsideAnother={true}
                  isRequired={true}
                  inputLabel="Product(s)"
                  field={field}
                  error={error}
                  isDropdown={true}
                  isSearchable={true}
                  isMulti={true}
                  dropdownData={
                    (productData ?
                      productData.map(
                        (procedure) => ({value: procedure.name, label: `${procedure.custom_fullname}`})
                      ) : []
                    ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                  }
                />
              )}
            />
          </div>

          {drugName && drugName.length > 0 && drugName.find((drug) => drug.includes("SUPARTZ")) ? (
            <div className="col-lg-6" onFocus={() => changeDatePickerVisibility(false)} tabIndex={-1}>
              <Controller
                name="prescription_attributes.qty"
                control={control}
                render={({field, fieldState: {error}}) => (
                  <div className="row mb-3">
                    <label
                      htmlFor="prescription_attributes.qty"
                      className="form-label col-lg-4 col-md-4 col-12"
                    >
                      SUPARTZ FX Qty*
                    </label>

                    <div className="col-lg-8 col-md-8 col-12">
                      <div className="input-group w-100">
                        <HubInputField
                          isSearchable={false}
                          parentClassNames="mb-0 col"
                          classNames={`rounded-start rounded-end-0 ${error ? "border-danger is-invalid" : ""}`}
                          inputPlaceholder="Select Qty..."
                          isDropdown={true}
                          isTypeAhead
                          dropdownData={
                            DRUG_QTY as unknown as OptionsOrGroups<string, GroupBase<string>>
                          }
                          inputId="prescription_attributes.qty"
                          field={field}
                          isRequired={true}
                          isRowBased={false}
                        />
                        <span 
                          className="input-group-text" id="basic-addon2"
                          style={{backgroundColor: '#e9ecef', color: '#495057'}}
                        >syringes</span>
                      </div>
                      {error && error.message ? (
                        <div dangerouslySetInnerHTML={{__html: error.message}}
                          className="text-danger text-small mt-2"
                        ></div>
                      ) : null}
                    </div>
                  </div>
                )}
              />
            </div>
          ) : null}
        </div>

        <div className="row">
          <div className="col-lg-6">
            <Controller
              name="prescription_attributes.scheduled_date_of_service"
              control={control}
              // defaultValue=""
              render={({ field, fieldState: { error } }) => (
                  <div className="row align-items-center mb-3">
                      <label htmlFor="patient_attributes.dob"
                             className="col-lg-4 col-md-4 col-12 form-label text-end mb-0 pe-0">
                          Scheduled Date of Service
                      </label>
                      <div className="col-lg-8 col-md-8 col-12 position-relative">
                          <DatePicker
                            selected={
                              field.value
                                ? parse(field.value, "yyyy-MM-dd", new Date()) // Parse the date from the default format if value exists
                                : null
                            }
                            onChange={(date) => {
                              field.onChange(date ? format(date, "yyyy-MM-dd") : ""); // Format back to yyyy-MM-dd
                              changeDatePickerVisibility(false)
                            }}
                            open={openDatePicker}
                            onClickOutside={() =>
                              changeDatePickerVisibility(false)
                            }
                            onFocus={() => changeDatePickerVisibility(true)}
                            onBlur={(e) => {
                              if (!e.currentTarget.contains(document.activeElement))
                                changeDatePickerVisibility(false)
                            }}
                            dateFormat="MM/dd/yyyy" // Display format
                            className={`form-control ${error?.message ? "is-invalid" : ""}`}
                            placeholderText="mm/dd/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            customInput={
                              <ReactInputMask mask="99/99/9999">
                                {(inputProps: {}) => <input id="prescription_attributes.scheduled_date_of_service" {...inputProps} />}
                              </ReactInputMask>
                            }
                            wrapperClassName="w-100"
                            minDate={new Date()} // Restrict past dates
                          />
                          <i
                            className="bi bi-calendar position-absolute"
                            style={{
                              right: error?.message ? "50px" : "25px", // Move left on validation error
                              top: "19.3px",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                            }}
                          ></i>
                          {/* Clear button */}
                          {field.value && (
                            <i
                              className="position-absolute bi bi-x text-body fs-4"
                              style={{
                                right: error?.message ? "75px" : "50px",
                                top: "19.3px",
                                transform: "translateY(-50%)",
                                padding: "0",
                              }}
                              role="button"
                              onClick={() => field.onChange("")}
                            ></i>
                          )}
                          {error && error.message ? (
                              <div
                                  dangerouslySetInnerHTML={{__html: error.message}}
                                  className="text-danger text-small mt-2"
                              ></div>
                          ) : null}
                      </div>
                  </div>
              )}
            />
          </div>

          <div className="col-lg-6" onFocus={() => changeDatePickerVisibility(false)} tabIndex={-1}>
            <Controller
              name="case_attributes.ship_to"
              control={control}
              // defaultValue="" // Set first value by default
              render={({ field, fieldState: { error } }) => (
                <HubInputField
                  inputId="case_attributes.ship_to"
                  isRowBased={true}
                  isRowInsideAnother={true}
                  isRequired={true}
                  inputLabel="Ship to"
                  field={field}
                  error={error}
                  isDropdown={true}
                  isSearchable={false}
                  isTypeAhead
                  dropdownData={SHIP_TO as unknown as OptionsOrGroups<string, GroupBase<string>>}
                />
              )}
            />
          </div>
        </div>

        {siteOfCare === "other" ? <SiteOfCareComp watch={watch} control={control} /> : null}

        <div className="row">
          <div className="col-12 col-sm-2"></div>
          <div className="col-12 col-sm-10">
            <Controller
              name="prescription_attributes.written_date"
              control={control}
              render={({field: {value}}) => (
                <div className="form-check mt-3 input-checkbox-disabled">
                  <input
                    className="form-check-input" type="checkbox"
                    
                    id="flexCheckIndeterminateDisabled"
                    disabled checked
                  />
                  <label className="form-check-label" htmlFor="flexCheckIndeterminateDisabled">
                    Dispense as Written (written date will be {value})
                  </label>
                </div>
              )}
            />

           {category !== "med" && (
             <Controller
              name="prescription_attributes.is_specialty_pharmacy_only"
              control={control}
              render={({field: {value, onChange}}) => (
                <div className="form-check mt-3">
                  <input
                    className="form-check-input" type="checkbox"
                    id="isSpecialityPharmacyOnlyCheckbox"
                    name="prescription_attributes.is_specialty_pharmacy_only"
                    checked={value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="isSpecialityPharmacyOnlyCheckbox">
                    If you would like to proceed by having this drug automatically scripted through
                    the
                    Pharmacy Channel please
                    check here. This alleviates you and your office from having to call in and give
                    verbal authorization. Upon
                    checking the box and hitting submit, the script will begin to be processed and
                    dispensed to the address
                    selected above.
                  </label>
                </div>
              )}
            />)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseStepOne;
